import React from 'react'

interface Props {
  classNames?: string
  label: string
  enabled: boolean
  onClick?: (event: React.MouseEvent) => void
}

export const PillButton = ({ classNames = '', label, enabled, onClick }: Props) => {
  return (
    <button
      className={`${classNames} ma1 pv2 ph3 f6 bn br-pill outline-0 pointer
        ${enabled ? 'white bg-blue500' : 'bg-gray100 hover-bg-gray300'}
      `}
      onClick={onClick}
    >
      {label}
    </button>
  )
}
